<template>
  <div class="auto-shutdown-details__row">
    <span v-if="isOnline" class="auto-shutdown-details__label">{{ t("shuttingDownIn") }} {{ uptimeDuration }}</span>
    <span v-else class="auto-shutdown-details__label">{{ t("onlineFor") }} {{ uptimeDuration }}</span>
  </div>
</template>

<script lang="ts">
import { useStore } from "@/composable/useStore"
import { createTranslationModule } from "@/plugins/i18n"
import Utils from "@/utils/utils"
import { ShutdownSettings } from "@/views/appLauncher/lib/types"
import { defineComponent, computed, PropType } from "@vue/composition-api"

export default defineComponent({
  name: "UptimeLabel",
  props: {
    isOnline: {
      type: Boolean,
      required: true
    },
    shutdown: {
      type: Object as PropType<ShutdownSettings>,
      required: true
    }
  },
  setup(props) {
    const t = createTranslationModule("WorkspaceEdit.Header.AutoShutdownDetails.Uptime")
    const { spaceModule } = useStore()

    const uptimeDuration = computed(() => {
      if (props.isOnline) {
        const { autoShutdownDefinition } = spaceModule.watching

        if (autoShutdownDefinition) {
          const { days, hours, min } = Utils.dateRange(Date.now(), autoShutdownDefinition.scheduledToShutdownAt)

          if (days) {
            return `${days} ${t("days")}`
          } else if (hours) {
            return `${hours}${t("h")} ${min}${t("min")}`
          } else {
            return `${min}${t("min")}`
          }
        }
      } else {
        const duration = props.shutdown.shutdownTimerInHours
        const [h, min] = `${duration}`.split(".")

        if (min) {
          return `${h}${t("h")} 30${t("min")}`
        } else {
          return `${h}${t("h")}`
        }
      }
    })

    return {
      t,
      uptimeDuration
    }
  }
})
</script>
